
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/action-plans",
      function () {
        return require("private-next-pages/action-plans.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/action-plans"])
      });
    }
  